module.exports = globalThis.mcData["tintsArray"] ?? globalThis.mcData["tints"]